module.exports = __webpack_public_path__ + "static/media/subGoogle4.3a21fbce.png";